(function ($) {
  $(function () {
    // SP検索フォームが存在するとき
    if ($('.js-prefBoxSp__region').length > 0) {
      $('.js-prefBoxSp__region__name').on('click', function (e) {
        var contents = $('+.prefBoxSp__region__contents', this)
        // アコーディオンの開閉制御
        contents.slideToggle(300);
        $(this).toggleClass('open');
      })

      $('.prefBoxSp__inner__typeSelectBox').each(function () {
        var label = $(this).find('.typeSelectLabel')
        // 最初の処理
        $(this).find(':checked').closest('label').parent('li').addClass('checked')
        // ラベルクリック
        label.on('click', function () {
          label.parent('li').filter('.checked').removeClass('checked')
          label.find(':checked').closest(label).parent('li').addClass('checked')
        })
      })
    }

    //
    $('.prefBoxPcMatchHeight').matchHeight()

    // タブ切り替え
    $('.js-ohakaSearchTabListItemSp').on('click', function () {
      var index = $('.ohakaSearchTabListItem').index(this)
      $('.ohakaSearchWrap').css('display', 'none')
      $('.ohakaSearchWrap').eq(index).css('display', 'block')
      $('.ohakaSearchTabListItem').removeClass('is-selected')
      $(this).addClass('is-selected')
    })
  })
})(jQuery)
